export default "__VITE_PUBLIC_ASSET__854745db__"